import { Container } from '../../components/container/container';
import { Page } from '../../components/page-layout/page';
import { createFileRoute } from '../../utils/route-factory';

function OutageAlerts() {
  return (
    <Page
      title='Outage Alerts'
      breadcrumbs={[
        {
          label: 'Global Settings',
        },
        {
          label: 'Outage Alerts',
        },
      ]}
    >
      <Container>TODO</Container>
    </Page>
  );
}

export const Route = createFileRoute({
  path: '/global-settings/outage-alerts',
  component: OutageAlerts,
  type: 'auth',
});
